import { useAuthContext } from '@providers/AuthProvider';
import { BillingAccountCard } from './BillingAccountCard';
import { Wrapper } from './styles/Wrapper';

export function BillingAccount() {
  const { organization } = useAuthContext();
  return (
    <Wrapper>
      <ul className="list">{organization?.billingAccount && <BillingAccountCard />}</ul>
    </Wrapper>
  );
}
